import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersubfull } from "../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { TableDanhSachThanhLy } from "./TableDanhSachThanhLy";
import { BtnXuatDanhSach } from "components/DanhSachThanhLy/ChucNang/XuatDanhSach/BtnXuatDanhSach";
import { BtnInDanhSach } from "components/DanhSachThanhLy/ChucNang/InDanhSach/BtnInDanhSach";
import DanhSachThanhLyApi from "../../service/danhSachThanhLyApi";
import LayoutV2 from "containers/LayoutV2";
export const DanhSachThanhLy = () => {
  //phân quyền
  const initQuyenDanhSachThanhLy = {
    danhsachthanhly: false,
    danhsachthanhly_dadoc: false,
  };

  const [quyenDanhSachThanhLy, setQuyenDanhSachThanhLy] = useState(
    initQuyenDanhSachThanhLy,
  );
  const LayQuyenQuanLyDanhSachThanhLy = () => {
    DanhSachThanhLyApi.phanquyenDanhSachThanhLy().then((response) => {
      // console.log(response.data);
      setQuyenDanhSachThanhLy({
        ...quyenDanhSachThanhLy,
        danhsachthanhly:
          response.data.danhsachthanhly_danhsach === null ||
          response.data.danhsachthanhly_danhsach === undefined
            ? false
            : response.data.danhsachthanhly_danhsach,
        danhsachthanhly_dadoc:
          response.data.danhsachthanhly_dadoc === null ||
          response.data.danhsachthanhly_dadoc === undefined
            ? false
            : response.data.danhsachthanhly_dadoc,
      });
    });
  };

  useEffect(() => {
    LayQuyenQuanLyDanhSachThanhLy();
  }, []);

  if (initQuyenDanhSachThanhLy.danhsachthanhly === null)
    return <LayoutV2></LayoutV2>;

  if (!quyenDanhSachThanhLy.danhsachthanhly) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div
              className="custom-table-cell text-center red"
              style={{ width: "100%" }}
            >
              Bạn không có quyền truy cập trang này!
            </div>
          </div>
        </h2>
      </LayoutV2>
    );
  }

  return (
    <LayoutV2>
      {quyenDanhSachThanhLy.danhsachthanhly && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Danh sách thanh lý</h1>
                        </div>
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        <div className="btn-group btn-light-v2">
                          <ul>
                            <li>
                              <BtnInDanhSach />
                            </li>
                            <li>
                              <BtnXuatDanhSach />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                    <SearchBarMobile />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableDanhSachThanhLy
            quyenDaDoc={quyenDanhSachThanhLy.danhsachthanhly_dadoc}
          />
        </div>
      )}

      {!quyenDanhSachThanhLy.danhsachthanhly && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <Headersubfull
                      title="Danh sách thanh lý"
                      icon1="mdi mdi-car"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
